var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingPagebottomSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 42,
    viewBox: "0 0 131 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9403 27.66C37.5784 27.66 43.7704 21.4681 43.7704 13.83C43.7704 6.19192 37.5784 0 29.9403 0C22.3023 0 16.1104 6.19192 16.1104 13.83C16.1104 21.4681 22.3023 27.66 29.9403 27.66Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8308 13.8L103.661 6.95996L101.651 4.94995L92.8008 13.8L101.651 22.65L103.661 20.6299L96.8308 13.8Z",
    fill: "#FF9D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.76 13.8L115.59 6.95996L113.58 4.94995L104.73 13.8L113.58 22.65L115.59 20.6299L108.76 13.8Z",
    fill: "#FF9D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.831 13.8L127.671 6.95996L125.651 4.94995L116.811 13.8L125.651 22.65L127.671 20.6299L120.831 13.8Z",
    fill: "#FF9D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8308 13.8L79.6608 6.95996L77.6508 4.94995L68.8008 13.8L77.6508 22.65L79.6608 20.6299L72.8308 13.8Z",
    fill: "#FF9D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7605 13.8L91.5905 6.95996L89.5805 4.94995L80.7305 13.8L89.5805 22.65L91.5905 20.6299L84.7605 13.8Z",
    fill: "#FF9D00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.93 41.67C0.87 41.67 0 40.8101 0 39.7401C0 38.6801 0.86 37.8101 1.93 37.8101C3 37.8101 3.86 38.6701 3.86 39.7401C3.86 40.8101 3 41.67 1.93 41.67Z",
    fill: "#0B315E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0696 41.67C19.0096 41.67 18.1396 40.8101 18.1396 39.7401C18.1396 38.6801 18.9996 37.8101 20.0696 37.8101C21.1396 37.8101 21.9996 38.6701 21.9996 39.7401C21.9996 40.8101 21.1296 41.67 20.0696 41.67Z",
    fill: "#0B315E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1995 41.67C37.1395 41.67 36.2695 40.8101 36.2695 39.7401C36.2695 38.6801 37.1295 37.8101 38.1995 37.8101C39.2595 37.8101 40.1295 38.6701 40.1295 39.7401C40.1295 40.8101 39.2695 41.67 38.1995 41.67Z",
    fill: "#0B315E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3402 41.67C55.2802 41.67 54.4102 40.8101 54.4102 39.7401C54.4102 38.6801 55.2702 37.8101 56.3402 37.8101C57.4002 37.8101 58.2702 38.6701 58.2702 39.7401C58.2702 40.8101 57.4002 41.67 56.3402 41.67Z",
    fill: "#0B315E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4798 41.67C73.4198 41.67 72.5498 40.8101 72.5498 39.7401C72.5498 38.6801 73.4098 37.8101 74.4798 37.8101C75.5398 37.8101 76.4098 38.6701 76.4098 39.7401C76.3998 40.8101 75.5398 41.67 74.4798 41.67Z",
    fill: "#0B315E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6097 41.67C91.5497 41.67 90.6797 40.8101 90.6797 39.7401C90.6797 38.6801 91.5397 37.8101 92.6097 37.8101C93.6697 37.8101 94.5397 38.6701 94.5397 39.7401C94.5397 40.8101 93.6697 41.67 92.6097 41.67Z",
    fill: "#0B315E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75 41.67C109.69 41.67 108.82 40.8101 108.82 39.7401C108.82 38.6801 109.68 37.8101 110.75 37.8101C111.81 37.8101 112.68 38.6701 112.68 39.7401C112.67 40.8101 111.81 41.67 110.75 41.67Z",
    fill: "#0B315E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88 41.67C127.82 41.67 126.95 40.8101 126.95 39.7401C126.95 38.6801 127.81 37.8101 128.88 37.8101C129.94 37.8101 130.81 38.6701 130.81 39.7401C130.81 40.8101 129.95 41.67 128.88 41.67Z",
    fill: "#0B315E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPagebottomSvg);
export default __webpack_public_path__ + "static/media/landingPagebottomSvg.f042a9ee26fb78091ff62a232e239d8e.svg";
export { ForwardRef as ReactComponent };